
import ThemeButton from './ThemeButton.vue';

import { Component, Prop, Vue } from 'vue-property-decorator';
import { ArticleAction, ConnectToAgent } from '@/common/bot/types';
import FaAngleRight from './icons/FaAngleRight.vue';
import FaAngleLeft from './icons/FaAngleLeft.vue';
import CustomerSupportIcon from './icons/CustomerSupportIcon.vue';
import { namespace } from 'vuex-class';

const userModule = namespace('user');

@Component({ components: { ThemeButton } })
export default class ArticleFeedback extends Vue {
  @Prop() readonly articleAction!: ArticleAction|null;
  @Prop(Boolean) readonly canConnectToSupport!: boolean;
  @Prop(Boolean) readonly enableMetadataRules!: boolean;

  @userModule.State('isLogin') isLogin!: boolean;

  loading = false;
  loadedConfig: ConnectToAgent | null = null;

  get buttons () {
    const buttons = [
      {
        id: 'back',
        text: this.$t('global.back'),
        prependIcon: FaAngleLeft,
        onClick: this.emitBackClick,
      },
    ];

    const { articleAction, canConnectToSupport, enableMetadataRules } = this;
    if (!canConnectToSupport && !articleAction && !enableMetadataRules) return buttons;

    // If we have connect, it does not matter if we have action, Connect
    // Will have first preference here.
    if (canConnectToSupport || (enableMetadataRules && this.isLogin)) {
      return [
        ...buttons,
        {
          id: 'need-more-help-btn',
          text: canConnectToSupport ? this.t('chat.sys.navigation.contact_support') : this.t('article.feedback.button.need_more_help'),
          onClick: this.emitConnectToAgent,
          prependIcon: CustomerSupportIcon,
        },
      ];
    }

    // No connect to support but has an article action.
    if (articleAction) {
      return [
        ...buttons,
        {
          id: 'article-action-btn-' + articleAction.action,
          text: articleAction.actionTitle,
          appendIcon: FaAngleRight,
          onClick: this.emitActionClick,
          filled: true,
        },
      ];
    }
    // SNR
    return buttons;
  }

  emitBackClick () {
    this.$emit('back');
  }

  emitActionClick () {
    this.$emit('action');
  }
  emitConnectToAgent () {
    this.$emit('connect');
  }
}
